// A display's language on screen: the design's first, or each in turn
// (layout/designLanguages.ts screenLanguages). Rotation changes words only: it
// never waits for a call, and a call never waits for it.
import { useEffect, useState } from 'react'
import type { ScreenLanguages } from '../layout/designLanguages'

/** Steps through count languages every rotateSec, calling onStep with the new index; returns stop. */
export function startRotation(count: number, rotateSec: number, onStep: (index: number) => void): () => void {
  if (count < 2 || rotateSec <= 0) return () => undefined
  let index = 0
  const timer = setInterval(() => {
    index = (index + 1) % count
    onStep(index)
  }, rotateSec * 1000)
  return () => clearInterval(timer)
}

/** The language a screen shows now; a new plan starts again at its first. */
export function useScreenLanguage(plan: ScreenLanguages): string {
  const key = `${plan.languages.join(',')}/${plan.rotateSec}`
  const [at, setAt] = useState({ key, index: 0 })
  const { languages, rotateSec } = plan
  const count = languages.length
  useEffect(() => startRotation(count, rotateSec, (index) => setAt({ key, index })), [key, count, rotateSec])
  const index = at.key === key ? at.index : 0
  return languages[index] ?? languages[0] ?? 'en'
}

/** The language a Called screen is drawn in: the one showing when its call took the screen. */
export interface HeldLanguage {
  key: string
  lang: string
}

/** Kept while the same call shows, and while it fades out; a new call takes the language now showing. */
export function calledLanguage(held: HeldLanguage | null, showing: string | null | undefined, now: string): HeldLanguage | null {
  if (!showing || held?.key === showing) return held
  return { key: showing, lang: now }
}
